import { render, staticRenderFns } from "./Gchatgoing.vue?vue&type=template&id=170a3051&scoped=true"
import script from "./Gchatgoing.vue?vue&type=script&lang=js"
export * from "./Gchatgoing.vue?vue&type=script&lang=js"
import style0 from "./Gchatgoing.vue?vue&type=style&index=0&id=170a3051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a3051",
  null
  
)

export default component.exports